/**
 * Registry of one-time user guides (anchored product tours, FE-1131).
 *
 * Mirrors the backend `UserGuide` enum (focalmonolith): a guide's enum
 * value is its persistence key on `GET/PUT /api/user-guide-completion`,
 * so values must stay stable once shipped and must match the backend
 * enum exactly — an unknown value is rejected with a 400.
 *
 * To add a guide:
 * 1. Add its value to the backend `UserGuide` enum, then mirror it here.
 * 2. Define its `UserGuideStep[]` config next to the feature it belongs
 *    to (see `conversationDetailsGuide.ts` for the reference example).
 * 3. Put `data-guide="..."` anchor attributes on the target elements.
 * 4. Mount `<UserGuide guideId={...} steps={...} enabled={...} />` on the
 *    page (from `@/components/common`).
 */
export enum UserGuideId {
  CONVERSATION_DETAIL = "CONVERSATION_DETAIL",
}
